"use client"

import { motion } from "framer-motion"
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion"

const faqs = [
  {
    question: "I’ve seen you at another clinic before – can I still see you?",
    answer: "Yes. If we’ve worked together in another clinic before and you’d like to continue your care, you’re welcome to book at either Tewantin or Maroochydore, whichever is more practical for you."
  },
  {
    question: "Do you work alongside IVF, GPs and other specialists?",
    answer: "Yes. Many people see Renee while also working with their GP, specialist, midwife or IVF clinic. Treatment is designed to sit alongside your medical care and to support you through the process, not to replace it.”"
  },
  {
    question: "Is acupuncture safe in pregnancy?",
    answer: "Acupuncture is commonly used during pregnancy. Your treatment is always tailored to your stage of pregnancy and your individual situation. If you’re under the care of a midwife, GP or obstetrician, treatment can be adjusted to align with their advice."
  },
  {
    question: "I’m not sure what kind of appointment I need – what should I do?",
    answer: "If you’re unsure which appointment type or clinic to choose, you’re welcome to get in touch and ask. A brief email or phone call is often enough to point you in the right direction."
  }
]

export function FAQ() {
  return (
    <section id="faq-section" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 pt-0 lg:pt-10 lg:pb-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl mb-4 text-[#3f4141]">FAQ</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
          Frequently Asked Questions.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl mx-auto"
        >
          <Accordion type="single" collapsible>
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-[#3f4141] text-xl font-light text-left">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
          {/* FAQPage Structured Data */}
          <script type="application/ld+json" dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: faqs.map((f) => ({
                '@type': 'Question',
                name: f.question,
                acceptedAnswer: { '@type': 'Answer', text: f.answer },
              })),
            }),
          }} />
        </motion.div>
      </div>
    </section>
  )
}